import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { GlobalService } from '../_services/global.service';
import { ToastrService } from 'ngx-toastr';
// import {Code} from '../_shared/code';
@Injectable()
export class AuthProjectGuard implements CanActivate {

  constructor( private globalService:GlobalService, private toastr: ToastrService) {
    
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if(route.routeConfig.path.includes('articles')) {
      return true;
    }
    let projectId=this.globalService.getProjectId();
    if(!projectId)
    {
        this.toastr.error('Vui lòng chọn một chủ đề để xem chi tiết bài viết và bài báo', 'Cảnh báo');
        setTimeout(() => {
          $("#toast-container").css({ "margin-top": "30px" });
        }, 0);
    }else
    {
        return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_guards/auth-project.guard.ts